<div class="content-wrapper">
  <div class="page-title-box">
    <h4>Zip Code List</h4>
  </div>
  <div class="card card-nobody">
    <div class="card-body">
      <div class="row mb-0">
        <div class="col-lg-8 col-sm-8">
          <div class="row search-box">
            <div class="col-lg-5 mb-2">
              <div class="position-relative">
                <input [formControl]="searchText"
                       class="form-control border-light rounded"
                       placeholder="Search..."
                       type="search">
                <i class="uil uil-search search-icon"></i>
              </div>
            </div>
            <div class="col-lg-5 mb-2">
              <div class="search-item">
                <ng-select (change)="changeSelect($event)"
                           [formControl]="partnerSelect"
                           [items]="partnerOptions"
                           [multiple]="false"
                           bindLabel="name"
                           bindValue="code"
                           class="form-control"
                           placeholder="Select Partner">
                </ng-select>
              </div>
            </div>
          </div>
        </div>

        <div class="col-lg-4 col-sm-4">
<!--          <div *ngIf="isCreatable && !isReadOnly" class="mt-4 mt-sm-0 d-flex align-items-center justify-content-sm-end">-->
<!--            <button (click)="importModalOpen()" class="btn btn-light btn-outline-black" type="button">-->
<!--              <font-awesome>Import</font-awesome>-->
<!--            </button>-->
<!--            <button (click)="modalOpen()" class="btn btn-dark ml-8px" type="button">-->
<!--              <font-awesome style="color:white">New</font-awesome>-->
<!--            </button>-->
<!--          </div>-->
        </div>
      </div>

      <div [ngClass]="{showDetail}" class="table-wrapper">

        <app-dp-list (pageEvent)="onPageEvent($event)"
                     (toggleDetail)="showDetail=$event"
                     [pagedResponse]="pagedResponse"
                     [selectedItem]="selectedData"
                     [showDetail]="showDetail">
          <table
            [ngClass]="{
              'table': !showDetail,
              'table-list' : !showDetail,
              'align-middle': !showDetail,
              'table-nowrap': !showDetail,
              'table-check': !showDetail,
              'w-100': true
              }">
            <thead>
            <tr>
              <th [attr.data-sort-fields]="'zipcode'" [hidden]="showDetail">Zip Code</th>
              <th [attr.data-sort-fields]="'partner'" [hidden]="showDetail">Service Provider</th>
              <th [attr.data-sort-fields]="'username'" [hidden]="showDetail">Update Date</th>
            </tr>
            </thead>

            <tbody>
            <tr (click)="selectRow(zipCode);"
                *ngFor="let zipCode of zipCodeData; let i = index"
                [class.active]="zipCode.zipcode === selectedData?.zipcode">
              <ng-container *ngIf="!showDetail; else detailListCols">
                <td>{{ zipCode?.zipcode }}</td>
                <td>{{ zipCode?.partner }}</td>
                <td>{{ zipCode?.auth?.updatedAt | hqDate }}</td>
              </ng-container>
              <ng-template #detailListCols>
                <td class="detail-area-container">
                  <div class="detail-area">
                    <div [ngClass]="{
                    'detail-row': true,
                    'list-card-container': true
                    }">
                      <div class="row">
                        <div class="col-5 detail-font-bold-12px">{{ zipCode?.zipcode }}</div>
                        <div class="col-5 detail-font-bold-12px">{{ zipCode?.partner }}</div>
                      </div>
                      <div class="row">
                        <div
                          class="col-5 detail-font-bold-12px detail-item-right">{{ zipCode?.auth?.updatedAt | date : 'medium' }}
                        </div>
                      </div>
                    </div>
                  </div>
                </td>
              </ng-template>
            </tr>
            </tbody>

          </table>
        </app-dp-list>

        <app-dp-detail *ngIf="showDetail && selectedData" [showDetail]="showDetail">
          <app-zip-code-detail (detailUpdateEvent)="reload($event)" [zipCodeInfo]="selectedData"></app-zip-code-detail>
        </app-dp-detail>


      </div>

    </div><!-- end card body -->
  </div><!-- end card -->
</div>
